import React from 'react';

import Photo from "../Photo/Photo";
import "./About.scss";
import { Article } from '../../components/Article/Article';


export const About = ()=>{
  return (
    <section className="About wall shadow">
      <div className="block"><Photo /></div>
      <Article src="about" className="block"/>
      <Article src="about.footer" className="block"/>
    </section>
  );
}

export default About;